export default __webpack_public_path__ + "static/media/waiting-room,-studio.aafd4888.jpg";